export const getActivityTags = `query MyQuery($hotelId: String!, $language: String){
    getActivityTags(input: {hotelId: $hotelId, lang: $language}) {
      hotelId
      name
      id
    }
  }`;
export const getActivities = `query MyQuery($hotelId: String!, $language: String){
    getActivities(input: {hotelId: $hotelId, lang: $language }) {
      createdAt
      createdBy
      description
      highlights
      hotelId
      icons
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      isActive
      label
      location
      name
      gender
      forChild
      minimumAge
      activityLocation {
        hotelLocation
        addressLine1
        addressLine2
        area
        city
        country
        latitude
        longitude
        postalCode
        state
        timezone
        url
        urlTitle
        locationType
      }
       schedule {
      alwaysActive
      endTime
      oneTime {
        date
      }
      recurring {
      addPadding
        dates
        paddingDuration
        slotDuration
        endDate
        recursWeek
        recurs
        startDate
        recurrences
        totalActivityTime
        recurringTimeSlots {
            startTime
            endTime
            capacity
            slotDuration
            paddingDuration
            gender
            isChild
            audienceType
        }
      }
      scheduleType
      startTime
    }
      tags
      cta {
        email
        status
        phoneNumber
        title
        type
      }
      waiver {
        status
        messageText
        checkboxes {
          label
        }
      }
      information {
        type
        email
        phone
        URL
        title
        displayTitle
      }
      bannerImage {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      customAttributes {
        key
        value
      }
      status
      bannerImageStatus
      capacity
      categoryId
      categoryName
      price
      residentsOnly
      updatedAt
      updatedBy
    }
  }`;

export const getActivityCategories = `query MyQuery($hotelId: String!, $language: String!){
  getActivityCategories(input: {hotelId: $hotelId, lang: $language }) {
    categoryCode
    createdAt
    createdBy
    hotelId
    id
    isActive
    name
    customAttributes {
      key
      value
    }
    updatedAt
    updatedBy
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
  }
}`;
